/** @jsx jsx */
import { jsx } from '@emotion/react'

interface Props {
  alt: string
  src: string
  className?: string
  loading?: 'lazy' | 'eager'
  decoding?: 'async' | 'auto' | 'sync'
}

const ImageResponsive: React.FC<Props> = ({
  src,
  alt,
  className,
  loading,
  decoding,
}) => {
  return (
    <img
      className={className}
      css={[
        {
          width: '100%',
        },
      ]}
      src={src}
      loading={loading}
      decoding={decoding}
      alt={alt}
    />
  )
}

export default ImageResponsive
